
import React from 'react';
import RichTextEditor from './RichTextEditor';
import { saveBusinessSetting } from '@/utils/businessService';

interface TermsEditorProps {
  initialContent: string;
  onSaved?: () => void;
}

const TermsEditor: React.FC<TermsEditorProps> = ({ initialContent, onSaved }) => {
  const handleSave = async (content: string) => {
    await saveBusinessSetting('terms', content);
  };

  return (
    <RichTextEditor
      title="Terms of Service"
      initialContent={initialContent}
      onSave={handleSave}
      onSaved={onSaved}
    />
  );
};

export default TermsEditor;
